<button
  mat-button
  [type]="options.type || 'button'"
  [color]="options.buttonColor"
  [class.active]="options.active"
  [class.mat-mdc-raised-button]="options.raised"
  [class.mat-mdc-outlined-button]="options.stroked"
  [class.mat-mdc-unelevated-button]="options.flat"
  [class.fullWidth]="options.fullWidth"
  [ngClass]="options.customClass"
  [disabled]="options.disabled"
  [attr.aria-disabled]="(options.active || options.disabled) ? 'true' : null"
  [attr.aria-label]="ariaLabel || null"
  [attr.aria-describedby]="ariaDescribedBy || null"
>
  <ng-container *ngIf="options.buttonIcon">
    <mat-icon
      [class.is-mat-icon]="!options.buttonIcon.fontSet"
      [ngClass]="options.buttonIcon.customClass"
      [fontSet]="options.buttonIcon.fontSet"
      [fontIcon]="options.buttonIcon.fontIcon"
      [color]="options.buttonIcon.color"
      [svgIcon]="options.buttonIcon.svgIcon"
      [inline]="options.buttonIcon.inline"
    >
      {{ options.buttonIcon.fontSet ? '' : options.buttonIcon.fontIcon }}
    </mat-icon>
  </ng-container>

  <span *ngIf="!options.active">{{ options.text }}</span>
  <span class="button-spinner" *ngIf="options.active && !options.disabled"></span>
</button>
